import { useMutation } from "@tanstack/react-query";
import { HTTP_ENDPOINTS } from "../../../../../../consts/api";
import { http } from "../../../../../../services/HttpService";

export const useEnrollNewPatient = (patientId, options = {}) => {
  const res = useMutation(
    (dto) =>
      http.post(
        HTTP_ENDPOINTS.patientFiIntegration.enrollNewPatient(patientId),
        dto,
      ),
    { ...options },
  );
  return res;
};
